import React, { useEffect, useState } from "react";

const DEFAULT_SETTINGS = {
  active_provider: "searxng",
  searxng_url: "http://127.0.0.1:8888",
  naver_client_id: "",
  naver_client_secret: "",
  tavily_api_key: "",
  providers: [],
};

const DEFAULT_PROVIDERS = [
  { id: "searxng", label: "로컬 SearXNG" },
  { id: "naver", label: "네이버 검색 API" },
  { id: "tavily", label: "Tavily API" },
];

function SearchSettingsPanel({ settings, onLoad, onSave, onTest }) {
  const [form, setForm] = useState(DEFAULT_SETTINGS);
  const [query, setQuery] = useState("오늘 주요 뉴스");
  const [busy, setBusy] = useState("");
  const [result, setResult] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!settings) return;
    setForm({
      ...DEFAULT_SETTINGS,
      ...settings,
      naver_client_id: "",
      naver_client_secret: "",
      tavily_api_key: "",
    });
  }, [settings]);

  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const run = async (type, action) => {
    setBusy(type);
    setResult(null);
    setMessage("");
    try {
      const data = await action();
      setResult(data.result || data.settings || data);
      if (type === "save") setMessage("검색 설정을 저장했습니다.");
    } catch (err) {
      setMessage(err.message || "처리 중 오류가 발생했습니다.");
    } finally {
      setBusy("");
    }
  };

  const providers = form.providers?.length ? form.providers : DEFAULT_PROVIDERS;

  return (
    <section className="search-settings-panel">
      <div className="admin-section-title">
        <div>
          <small>검색 엔진</small>
          <h3>검색 관리</h3>
          <p>
            기본은 무료 로컬 SearXNG를 사용하고, 필요할 때 네이버나 Tavily를 보조 검색으로
            연결할 수 있습니다.
          </p>
        </div>
        <button className="admin-refresh-button" onClick={onLoad} disabled={busy === "load"}>
          새로고침
        </button>
      </div>

      <div className="search-settings-grid">
        <label>
          <span>기본 검색 공급자</span>
          <select value={form.active_provider} onChange={(event) => update("active_provider", event.target.value)}>
            {providers.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>로컬 SearXNG 주소</span>
          <input
            value={form.searxng_url || ""}
            onChange={(event) => update("searxng_url", event.target.value)}
            placeholder="http://127.0.0.1:8888"
          />
        </label>

        <label>
          <span>네이버 Client ID</span>
          <input
            value={form.naver_client_id || ""}
            onChange={(event) => update("naver_client_id", event.target.value)}
            placeholder="기존 값을 유지하려면 비워두세요"
          />
        </label>

        <label>
          <span>네이버 Client Secret</span>
          <input
            type="password"
            value={form.naver_client_secret || ""}
            onChange={(event) => update("naver_client_secret", event.target.value)}
            placeholder="기존 값을 유지하려면 비워두세요"
          />
        </label>

        <label>
          <span>Tavily API Key</span>
          <input
            type="password"
            value={form.tavily_api_key || ""}
            onChange={(event) => update("tavily_api_key", event.target.value)}
            placeholder="선택 사항"
          />
        </label>
      </div>

      <div className="search-provider-notes">
        <strong>권장 운영 방식</strong>
        <p>1. 서버 안에 SearXNG를 설치해 무료 통합 검색으로 사용합니다.</p>
        <p>2. 네이버나 Tavily 키는 로컬 검색 장애 시 보조 검색으로만 사용합니다.</p>
        <p>3. "검색해줘", "오늘 뉴스", "날씨", "시세" 같은 요청은 이 설정을 기준으로 검색합니다.</p>
      </div>

      {message && <div className={`search-inline-message ${message.includes("오류") || message.includes("실패") ? "error" : ""}`}>{message}</div>}

      <div className="search-test-box">
        <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="검색 테스트 문장" />
        <button className="admin-primary-button" disabled={!!busy} onClick={() => run("test", () => onTest({ ...form, query }))}>
          {busy === "test" ? "테스트 중" : "검색 테스트"}
        </button>
        <button className="admin-approve-button" disabled={!!busy} onClick={() => run("save", () => onSave(form))}>
          {busy === "save" ? "저장 중" : "설정 저장"}
        </button>
      </div>

      {result && (
        <div className={`search-test-result ${result.ok === false || result.status === "error" ? "error" : ""}`}>
          <strong>결과</strong>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </section>
  );
}

export default SearchSettingsPanel;
